import React, { memo } from 'react';
import clsx from 'clsx';
import { BoutiqueCalendarEventConfig } from './boutique-calendar.constants';
import { BoutiqueCalendarLayoutEvent } from './boutique-calendar.types';
import { formatBoutiqueTimeRange } from './boutique-calendar.utils';
import '@/assets/styles/views/boutique-classroom/boutique-calendar/boutique-calendar-event-card.styles.scss';

interface Props {
	event: BoutiqueCalendarLayoutEvent;
	isActive: boolean;
	onClick: (event: BoutiqueCalendarLayoutEvent, anchorElement: HTMLElement) => void;
}

export const BoutiqueCalendarEventCard: React.FC<Props> = memo(({ event, isActive, onClick }) => {
	const eventConfig = BoutiqueCalendarEventConfig[event.eventType];
	const isNarrow = event.laneCount > 1;

	return (
		<button
			type="button"
			className={clsx('boutique-calendar-event-card', event.variant ?? eventConfig?.variant, { narrow: isNarrow, active: isActive })}
			style={
				{
					'--boutique-event-top': event.topRatio,
					'--boutique-event-span': event.spanRatio,
					'--boutique-event-lane': event.laneIndex,
					'--boutique-event-lane-count': event.laneCount
				} as React.CSSProperties
			}
			onClick={clickEvent => onClick(event, clickEvent.currentTarget)}>
			<span className="boutique-calendar-event-card-indicator" />
			<span className="boutique-calendar-event-card-info">
				<span className="boutique-calendar-event-card-time">{formatBoutiqueTimeRange(event.startTime, event.endTime)}</span>
				<span className="boutique-calendar-event-card-title">{event.title}</span>
				{Boolean(event.description) && <span className="boutique-calendar-event-card-description">{event.description}</span>}
			</span>
			{Boolean(eventConfig) && <span className="boutique-calendar-event-card-badge">{eventConfig.label}</span>}
			{Boolean(eventConfig?.decorationUrl) && !isNarrow && (
				<img
					className="boutique-calendar-event-card-decoration"
					src={eventConfig.decorationUrl}
					alt=""
				/>
			)}
		</button>
	);
});

BoutiqueCalendarEventCard.displayName = 'BoutiqueCalendarEventCard';

export default BoutiqueCalendarEventCard;
